import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=b1461390&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1461390",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1461390')) {
      api.createRecord('b1461390', component.options)
    } else {
      api.reload('b1461390', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=b1461390&scoped=true&", function () {
      api.rerender('b1461390', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26jlLO5SEQX33/JS/comp/Accordion.vue"
export default component.exports